$(document).on('ajax:error', function() {
    $('#errorModal').modal('show');
});
